import React from "react";
import { Loader2 } from "lucide-react";

export default function Loading({ label = "Carregando..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-10 gap-3 text-slate-500" data-testid="loading">
      <Loader2 className="animate-spin text-[#00357C]" size={28} />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function Skeleton({ className = "" }) {
  return <div className={`bg-slate-200/70 animate-pulse rounded-xl ${className}`} />;
}
